import { initializeApp, getApps } from "firebase/app";
import { getAnalytics, isSupported, logEvent } from "firebase/analytics";

// Same Firebase project already used by applications/dashboard for messaging
// (see applications/dashboard/app/(dashboard)/notifications/firebase.ts).
// Analytics is a separate product within that project — no new project needed.
const firebaseConfig = {
  apiKey: "AIzaSyBemmM5i8KpqZget2XrZxqBuY7ncWfWPMQ",
  authDomain: "urtentic-45f63.firebaseapp.com",
  projectId: "urtentic-45f63",
  storageBucket: "urtentic-45f63.firebasestorage.app",
  messagingSenderId: "911552727018",
  appId: "1:911552727018:web:01f3b7c9a33cb5c79c1493",
  measurementId: "G-Y064GF5X1X",
};

const PRODUCTION_HOSTNAME = "verify.urtentic.com";

// Opt-in for e2e runs only (e.g. tests/e2e/phone-check.spec.ts), which stub
// window.gtag so no event reaches the real GA4 property. Never set it for a
// real deploy. It's a build-time CRA variable, so it only takes effect when the
// dev server or build is started with it set.
const ANALYTICS_FORCED_ON = process.env.REACT_APP_ANALYTICS_ENABLED === "true";

// isSupported() rejects in contexts Analytics can't run in (no IndexedDB,
// e.g. some in-app webviews or storage-restricted third-party iframes) —
// resolved once and reused so every trackEvent call doesn't re-probe it.
// Gated to the production hostname so local dev and any other deploy target
// never pollutes real funnel data.
const analyticsReady = (async () => {
  try {
    if (window.location.hostname !== PRODUCTION_HOSTNAME && !ANALYTICS_FORCED_ON) return null;
    const supported = await isSupported();
    if (!supported) return null;
    const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
    return getAnalytics(app);
  } catch (err) {
    console.error("Analytics initialization failed", err);
    return null;
  }
})();

/**
 * Fire-and-forget funnel event. Must never throw or block the verification
 * flow — a dropped analytics event is acceptable, a broken verification isn't.
 */
export async function trackEvent(eventName, params = {}) {
  try {
    const analytics = await analyticsReady;
    if (!analytics) return;
    logEvent(analytics, eventName, params);
  } catch (err) {
    console.error(`Analytics event "${eventName}" failed`, err);
  }
}
